import { render, staticRenderFns } from "./RuleBarLayout.vue?vue&type=template&id=bedf1bb0&"
import script from "./RuleBarLayout.vue?vue&type=script&lang=js&"
export * from "./RuleBarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports